import React from 'react';
import './TopbarPilotage.css';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import AssignedPage from './AssignedPage/AssignedPage';
import { withFirebase } from '../Firebase';
import StartedPage from './StartedPage/StartedPage';
import FinishedPage from './FinishedPage/FinishedPage';
import PendingPage from './PendingPage/PendingPage';

const SELECTED_KEY_PILOTAGE = 'SELECTED_KEY_PILOTAGE'

function TabContainer(props) {
  return (
    <Typography component="div">
      {props.children}
    </Typography>
  );
}

const style = {
  tab: {
    backgroundColor: "white",
    boxShadow: "0 0 10px 0 rgba(189,189,189,0.5)",
  }
}

const theme = createMuiTheme({
  palette: {
    primary: { main: '#0070A2' },
  },
  typography: { useNextVariants: true },
});

const styles = theme => ({
  indicator: {
    backgroundColor: '#0070A2',
    height: '4px',
  },
  textColorSelect: {
    color: '#0070A2'
  },
  phoneTabRoot: {
    textTransform: 'initial',
  },
  tabRoot: {
    textTransform: 'initial',
    color: 'rgba(0,0,0,0.54)',
    '&$tabSelected': {
      color: '#0070A2',
    },
    '&:hover': {
      color: '#0070A2',
      opacity: 1,
    },
    '&:focus': {
      color: '#0070A2',
    },
  },
  tabSelected: {}
})


class TopbarPilotage extends React.Component {
  state = {
    value: this.props.value || parseInt(localStorage.getItem(SELECTED_KEY_PILOTAGE)) || 0,
    numberPending: 0,
    numberAssigned: 0,
    numberStarted: 0,
    numberFinished: 0,
    currentUserManager: '',
    myCompany: '',
  };

  componentDidMount() {
    document.body.style.background = "#F8F9FB";

    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

      if (currentUser === null) {
        return
      }

      let querySnapshotUsers = await this.props.firebase.db.collection('users').get()
      const currentUserInfos = querySnapshotUsers.docs
        .filter(user => user.id === currentUser.uid)
        .map(doc => doc.data())[0];
      const currentUserManager = currentUserInfos.manager;
      const myCompany = currentUserInfos.company;
      this.setState({ currentUserManager, myCompany })
      this.updateTopBar();
    });

  }

  updateTopBar = async () => {
    let numberAssigned = 0;
    let numberStarted = 0;
    let numberFinished = 0;
    let numberPending = 0;
    let { currentUserManager, myCompany } = this.state;
    let querySnapshotCapsulesPeers = await this.props.firebase.db.collection('capsules').where('managers', 'array-contains', currentUserManager).get()
    let querySnapshotCapsulesTeam = await this.props.firebase.db.collection('capsules').where('managers', 'array-contains', this.props.firebase.auth.currentUser.uid).get()
    let querySnapshotAssignments = await this.props.firebase.db.collection('assignments').where('company', '==', myCompany).get()

    let propelledCapsulesIds = querySnapshotAssignments.docs.map(doc => doc.data().assignedCapsule)
    const dataPeers = querySnapshotCapsulesPeers.docs.map(doc => {
      let data = doc.data()
      return {
        id: doc.id,
        ...data
      }
    })
    const dataTeam = querySnapshotCapsulesTeam.docs.map(doc => {
      let data = doc.data()
      return {
        id: doc.id,
        ...data
      }
    })

    dataPeers.forEach(doc => {
      if (propelledCapsulesIds.includes(doc.id) && !doc.assigneeId) {
        numberAssigned += 1
      }
      if (doc.status === "pending") {
        numberPending += 1
      }
      if (doc.status === "begin") {
        numberStarted += 1
      }
      if (doc.status === "finish") {
        numberFinished += 1
      }
    });

    const peersDocIds = dataPeers.map(doc => doc.id)
    dataTeam.forEach(doc => {
      if (!peersDocIds.includes(doc.id)) { //avoid duplicates
        if (propelledCapsulesIds.includes(doc.id) && !doc.assigneeId) {
          numberAssigned += 1
        }
        if (doc.status === "pending") {
          numberPending += 1
        }
        if (doc.status === "begin") {
          numberStarted += 1
        }
        if (doc.status === "finish") {
          numberFinished += 1
        }
      }
    });
    this.setState({ numberAssigned, numberPending, numberStarted, numberFinished })
  }

  handleChange = (event, value) => {
    localStorage.setItem(SELECTED_KEY_PILOTAGE, value)
    this.setState({ value });
  };

  topbarPhone = () => {
    const { value } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <AppBar position="static" style={style.tab}>
          <MuiThemeProvider theme={theme}>
            <Tabs value={value}
              onChange={this.handleChange}
              indicatorColor="primary"
              variant="scrollable"
              textColor="primary">
              <Tab classes={{ root: classes.phoneTabRoot }} label={"Capsules propulsées (" + this.state.numberAssigned + ")"} />
              <Tab classes={{ root: classes.phoneTabRoot }} label={"Capsules acceptées (" + this.state.numberPending + ")"} />
              <Tab classes={{ root: classes.phoneTabRoot }} label={"Capsules activées (" + this.state.numberStarted + ")"} />
              <Tab classes={{ root: classes.phoneTabRoot }} label={"Capsules réalisées (" + this.state.numberFinished + ")"} />
            </Tabs>
          </MuiThemeProvider>
        </AppBar>
        {value === 0 && <TabContainer><AssignedPage /></TabContainer>}
        {value === 1 && <TabContainer><PendingPage /></TabContainer>}
        {value === 2 && <TabContainer><StartedPage /></TabContainer>}
        {value === 3 && <TabContainer><FinishedPage /></TabContainer>}
      </div>
    )
  }

  topbarWeb = () => {
    const { value } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <AppBar position="static" style={style.tab}>
          <Tabs value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            classes={{ indicator: classes.indicator }}
            centered>
            <Tab classes={{ selected: classes.tabSelected, root: classes.tabRoot }} label={"Capsules propulsées (" + this.state.numberAssigned + ")"} />
            <Tab classes={{ selected: classes.tabSelected, root: classes.tabRoot }} label={"Capsules acceptées (" + this.state.numberPending + ")"} />
            <Tab classes={{ selected: classes.tabSelected, root: classes.tabRoot }} label={"Capsules activées (" + this.state.numberStarted + ")"} />
            <Tab classes={{ selected: classes.tabSelected, root: classes.tabRoot }} label={"Capsules réalisées (" + this.state.numberFinished + ")"} />
          </Tabs>
        </AppBar>
        {value === 0 && <TabContainer><AssignedPage /></TabContainer>}
        {value === 1 && <TabContainer><PendingPage /></TabContainer>}
        {value === 2 && <TabContainer><StartedPage /></TabContainer>}
        {value === 3 && <TabContainer><FinishedPage /></TabContainer>}
      </div>
    )
  }
  render() {
    let width = window.innerWidth;
    if (width > 768) {
      return (
        <div>
          {this.topbarWeb()}
        </div>
      )
    } else {
      return (
        <div>
          {this.topbarPhone()}
        </div>
      )
    }
  }
}


export default withFirebase(withStyles(styles)(TopbarPilotage));